/* eslint-disable max-len */
/* eslint-disable no-irregular-whitespace */
/* <h2>1. 首部及导言</h2> */
export default {
  title: "域名push服务协议",
  content:`
    <p>1.域名push即域名过户，是指在域见未来平台上管理的域名从一个域见未来账号转移到另一个域见未来账号的行为</p>
    <p class="tips">2.域见未来是一个基于域名注册、交易、管理的平台，您务必确保在域见未来上PUSH的域名信息具有真实性、合法性、有效性，不得恶意使用本服务。若出现此类情况，域见未来有权立即停止提供服务，收回域见未来域名帐号并由相关用户承担由此而产生的一切后果。</p>
    <p class="tips">3.您理解并同意：域见未来有权要求PUSH发起方和接收方提供相应的身份证明等资料，您须保证提供的资料或信息的真实性、有效性，否则域见未来有权拒绝向您提供域名PUSH服务。</p>
    <p class="tips">4.您理解并保证：您所提交PUSH的域名不涉及任何争议、纠纷、诉讼、仲裁等情况，若出现此类问题，发起方与接收方均友好协商解决方式或通过法律途径解决，相关事宜与域见未来无关，域见未来有权随时停止、取消您的域名PUSH，并有权对域名进行冻结及其他操作。</p>
    <p class="tips">5.您通过自行设置的账号管理密码和安全验证提交的push申请，都视为是您本人的操作。由于账户密码自行保管不善丢失或泄露，导致域名被盗转或被接收PUSH导致的域名及款项损失，域见未来将不承担责任。</p>
    <p class="tips">6.您理解并保证遵守以下域名PUSH规则：</p>
    <p class="tips">6.1域名处于正常状态，与任何正在解决的域名争议及纠纷无关；</p>
    <p class="tips">6.2域名不处于在司法机构、仲裁机构或域名争议解决机构处理期间；</p>
    <p class="tips">6.3域名不处于拖欠注册费用状态中，若域名到期且未续费不得进行PUSH操作；</p>
    <p class="tips">6.4不存在任何未授权发起PUSH或接收PUSH的情况。</p>
    <p class="tips">7.在PUSH过程中，如果对方还未接收，您有权取消PUSH。如对方已经接收成功，则域名PUSH成功，您不再有权要求退还或取消PUSH操作。</p>
    <p class="tips">8. 您理解并同意：域名push成功后域名注册信息将变更为新持有人的信息。您确认发起push或确认接收push，即视为您同意变更域名注册信息，并承担相应责任义务。若域名在push之前设置了隐私保护将会被取消，且在接收后的7天内无法再次设置隐私保护。</p>
    <p class="tips">9.域见未来为您提供相关的PUSH过户服务，此项服务为域名过户功能，如涉及到资金问题请自行评估风险，并自行核对域名本身及域名相关信息的准确性。域见未来保证您域名在PUSH过程中款项和域名能够安全过户。</p>
    <p class="tips">10.您在域名PUSH过程中，如有遇到问题，域见未来有义务协助进行解决，以帮助您顺利完成PUSH行为，但域见未来不因此承担其中由于非域见未来原因导致的损失。</p>
    `,
};
